import { render, staticRenderFns } from "./GroupBookingAggregatedChoiceDialog.vue?vue&type=template&id=729983eb&"
import script from "./GroupBookingAggregatedChoiceDialog.vue?vue&type=script&lang=js&"
export * from "./GroupBookingAggregatedChoiceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports